import { featuredCategories } from '@/mocks/categories';

const categoryImages: Record<string, string> = {
  "feat-shoes-01": "https://readdy.ai/api/search-image?query=Stylish%20modern%20sneakers%20in%20warm%20beige%20and%20cream%20tones%20placed%20on%20a%20textured%20linen%20surface%20with%20soft%20natural%20window%20light%20from%20above%20creating%20gentle%20shadows%20minimalist%20product%20photography%20elegant%20editorial%20style%20neutral%20warm%20background&width=600&height=500&seq=cat-grid-shoes-v2&orientation=portrait",
  "feat-hoodies-01": "https://readdy.ai/api/search-image?query=Comfortable%20relaxed%20fit%20hoodie%20in%20soft%20sage%20green%20color%20neatly%20folded%20on%20a%20light%20oak%20wooden%20surface%20with%20subtle%20grain%20texture%20natural%20morning%20light%20streaming%20diagonally%20calm%20aesthetic%20with%20organic%20peaceful%20atmosphere&width=600&height=500&seq=cat-grid-hoodies-v2&orientation=portrait",
  "feat-tshirts-01": "https://readdy.ai/api/search-image?query=Premium%20quality%20cotton%20t-shirt%20in%20warm%20ivory%20tone%20laid%20flat%20on%20a%20speckled%20cream%20surface%20with%20soft%20directional%20light%20highlighting%20fabric%20texture%20and%20stitching%20details%20minimalist%20fashion%20flatlay%20with%20clean%20composition&width=600&height=500&seq=cat-grid-tshirts-v2&orientation=portrait",
  "feat-jackets-01": "https://readdy.ai/api/search-image?query=Elegant%20tailored%20jacket%20in%20camel%20brown%20color%20hanging%20on%20a%20wooden%20hanger%20against%20a%20softly%20lit%20cream%20wall%20with%20gentle%20diffuse%20lighting%20creating%20subtle%20depth%20sophisticated%20editorial%20fashion%20photography%20with%20refined%20minimalist%20style&width=600&height=500&seq=cat-grid-jackets-v2&orientation=portrait",
  "feat-accessories-01": "https://readdy.ai/api/search-image?query=Curated%20collection%20of%20fashion%20accessories%20including%20a%20leather%20strap%20watch%20minimalist%20bracelet%20and%20stylish%20sunglasses%20arranged%20on%20a%20round%20marble%20tray%20on%20a%20warm%20beige%20surface%20with%20soft%20golden%20hour%20lighting%20luxury%20lifestyle%20photography&width=600&height=500&seq=cat-grid-accessories-v2&orientation=portrait",
  "feat-bags-01": "https://readdy.ai/api/search-image?query=Structured%20crossbody%20bag%20in%20rich%20tan%20leather%20with%20gold%20tone%20hardware%20placed%20on%20a%20clean%20light%20cream%20surface%20with%20a%20subtle%20shadow%20cast%20by%20soft%20natural%20side%20lighting%20elegant%20product%20photography%20with%20timeless%20sophisticated%20aesthetic&width=600&height=500&seq=cat-grid-bags-v2&orientation=portrait",
  "feat-jersey-01": "https://readdy.ai/api/search-image?query=Athletic%20sports%20jersey%20in%20deep%20forest%20green%20with%20white%20details%20folded%20neatly%20on%20a%20gym%20bench%20with%20soft%20natural%20light%20from%20nearby%20window%20active%20lifestyle%20photography%20with%20clean%20sporty%20aesthetic%20and%20motivational%20atmosphere&width=600&height=500&seq=cat-grid-jersey-v2&orientation=portrait",
  "feat-headwear-01": "https://readdy.ai/api/search-image?query=Trendy%20baseball%20cap%20in%20warm%20caramel%20color%20with%20subtle%20embroidered%20detail%20placed%20on%20a%20light%20linen%20textured%20surface%20with%20dappled%20sunlight%20filtering%20through%20leaves%20above%20creating%20artistic%20shadow%20patterns%20casual%20lifestyle%20photography&width=600&height=500&seq=cat-grid-headwear-v2&orientation=portrait",
};

export default function CategoryGrid() {
  return (
    <section id="categories" className="relative py-20 md:py-28 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="mb-14 md:mb-16">
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
            <div>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
                Popular Categories
              </h2>
              <p className="mt-2 text-sm md:text-base text-foreground-600">
                Explore curated product categories from our superbuy spreadsheet
              </p>
            </div>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
            >
              View All Categories &rarr;
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuredCategories.map((cat, index) => (
            <a
              key={index}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative h-72 rounded-2xl overflow-hidden cursor-pointer"
            >
              <img
                src={categoryImages[cat.imageSeq]}
                alt={cat.name}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent">
                <div className="absolute top-3 right-3">
                  <span className="px-3 py-1 bg-background-50/90 backdrop-blur-sm text-foreground-900 text-xs font-medium rounded-full whitespace-nowrap">
                    {cat.priceLabel}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="text-lg font-heading font-semibold text-white">
                    {cat.name}
                  </h3>
                  <p className="mt-1 text-sm text-white/70">
                    {cat.subtitle}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}